// Google Tag Managerのイベントトラッキングjs

document.addEventListener('click', function(event) {
  // クリックされた要素が .js-track-site-logo またはその子要素か判定
  const targetSiteLogo = event.target.closest('.js-track-site-logo');

  // クリックされた要素が .js-track-mobile-nav またはその子要素か判定
  const targetLink = event.target.closest('.js-track-mobile-nav');

  window.dataLayer = window.dataLayer || [];

  if (targetSiteLogo) {
    // 🔸ヘッダーのロゴクリック
    const navLabel = targetSiteLogo.getAttribute('data-nav-label');

    window.dataLayer.push({
      'event': 'click_site_logo', // GTMでトリガーにするイベント名
      'nav_label': navLabel,      // 識別用
      'path_from': window.location.pathname  // どのページから
    });
  } else if (targetLink) {
    // 🔸ヘッダーのナビゲーションクリック
    const navLabel = targetLink.getAttribute('data-nav-label');

    // GTMのdataLayerにイベントをプッシュ
    window.dataLayer.push({
      'event': 'click_mobile_nav', // GTMでトリガーにするイベント名
      'nav_label': navLabel,        // どのボタンか
      'path_from': window.location.pathname  // どのページから
    });
  }
});